import React from "react";
import { MatApoyo } from "../Generals";

export default function Lesson8({ idLesson, data, setLoading }) {
  
  return (
    <div className="texto_parrafo">
      <p>
        ¡Comencemos con el <b>Voto desde el extranjero!</b>
      </p>
      <p>
        En las elecciones del próximo 2 de junio de 2024, las y los mexicanos residentes en el extranjero tendrán la oportunidad de participar 
        en la elección para la Presidencia de la República y senadurías, así como en la de gubernaturas o la jefatura de gobierno para algunas 
        entidades federativas. Este proceso electoral ofrece a las y los ciudadanos mexicanos en el extranjero la posibilidad de ejercer su 
        derecho al voto activo el cual se llevará a cabo a través de tres modalidades: el voto postal, electrónico y presencial.
      </p>
      <p>
        Para emitir el voto desde el extranjero, las y los ciudadanos mexicanos deben cumplir con ciertos requisitos:
      </p>
      <p>
        <div className="listPunto">Ser ciudadana o ciudadano mexicano</div>
        <div className="listPunto">Tener al menos 18 años de edad</div>
        <div className="listPunto">Residir en el extranjero</div>
        <div className="listPunto">Contar con Credencial para Votar vigente</div>
        <div className="listPunto">Solicitar inscripción en el Padrón Electoral y Lista Nominal del Electorado Residente en el Extranjero</div>
        <div className="listPunto">Manifestar su intención de voto</div>
      </p>
      <p>
        La Inscripción en la Lista Nominal del Electorado Residente en el Extranjero se realiza entre el 1° de septiembre de 2023 y el 20 de 
        febrero de 2024, se caracteriza porque:
      </p>
      <p>
        <div className="listPunto">No incluye fotografías</div>
        <div className="listPunto">Puede ser verificada por el INE</div>
        <div className="listPunto">Es temporal</div>
        <div className="listPunto">Se diferencia por modalidad de voto</div>
      </p>
      <p>
        Puedes identificar las modalidades del voto postal y electrónico conforme a las siguientes características:
      </p>
      <p>
        <b>Modalidad Postal:</b>
        <div className="listPunto">Las y los electores reciben la documentación electoral por correo postal</div>
        <div className="listPunto">Los votos serán recibidos por el INE para su resguardo hasta el día de la Jornada Electoral</div>
        <div className="listPunto">Serán contabilizados los votos recibidos hasta 24 horas antes del inicio de la Jornada Electoral</div>
        <div className="listPunto">Los votos recibidos después de este plazo son destruidos sin abrir</div>   
      </p>
      <p>
        <b>Modalidad Electrónica:</b>
        <div className="listPunto">Se emite a través del Sistema de Voto Electrónico por Internet (SIVEI)</div>
        <div className="listPunto">Se recibe una clave y contraseña de acceso</div>
        <div className="listPunto">El proceso cierra automáticamente a las 18:00 p.m. (hora central de México) el día de la elección</div>
        <div className="listPunto">El escrutinio y cómputo se realiza en una mesa de escrutinio y cómputo (MEC) electrónica</div>
      </p>
      <p>
        Te invitamos a ver el siguiente video en el que te explicamos los procedimientos para llevar a cabo el voto en el extranjero en modalidad postal y electrónica.
      </p>
      {data && data.indexOf(0) && <MatApoyo array={[data[0]]}/>}<br/><br/>
      <p>
        El voto en el extranjero en <b>modalidad presencial</b> se lleva a cabo a través de Módulos Receptores de Votación (MRV), que son
        lugares físicos donde se instalarán dispositivos para recibir a la ciudadanía que acuda a votar de forma presencial por medios
        electrónicos a través de internet, los cuales estarán ubicados en sedes consulares y contarán con el material necesario para su
        funcionamiento.
      </p>
      <p>
        {"El día de la elección, el personal de los MRV se encargará de instalar los módulos, identificar a las y los electores, brindar \
        las cuentas de acceso al sistema de voto electrónico por internet (SIVEI), emitir los votos y, en caso necesario, registrar incidentes.\
         Una vez concluida la votación en los MRV, se realizará el escrutinio y cómputo de los votos en una mesa de escrutinio y cómputo (MEC)\
          electrónica en territorio nacional."
        }
      </p>
      <p>Revisa el siguiente video e identifica las características de la votación desde el extranjero en modalidad presencial</p>
      {data && data.indexOf(1) && <MatApoyo array={[data[1]]}/>}<br/><br/>
      <p>
        Es momento de repasar lo aprendido hasta el momento, te invitamos a realizar la actividad interactiva.
      </p>
      {data && data.indexOf(2) && <MatApoyo array={[data[2]]}/>}<br/><br/>
      <p>
        Ahora revisemos lo relativo <b>al Voto Anticipado:</b>
      </p>
      <p>
        Los requisitos mínimos para ejercer el <b>Voto Anticipado</b> incluyen encontrarse impedido o impedida para acudir a una casilla el 
        día de la Jornada Electoral, haber solicitado, entre 2018 y 2023, la emisión de la Credencial para Votar desde su domicilio, 
        en apego a lo establecido por el artículo 141 de la Ley General de Instituciones y Procedimientos Electorales, manifestar su 
        intención de registrarse en la Lista Nominal de Electores con Voto Anticipado (LNEVA) a través de una solicitud de inscripción 
        y que esta sea dictaminada como procedente.
      </p>
      <p>
        Esta modalidad de votación se llevará a cabo antes de la Jornada Electoral, para lo cual personal del INE acudirá a cada uno de 
        los domicilios de las personas con voto anticipado con los materiales necesarios para la emisión del voto, garantizando su 
        secrecía. De esta forma, las personas con voto anticipado emitirán su voto desde su domicilio, para lo cual podrán auxiliarse 
        de una persona de confianza. Las representaciones de partidos políticos y observadores electorales podrán acompañar los recorridos, 
        pero no podrán ingresar a los domicilios.
      </p>
      <p>
        Revisa el siguiente video en el que te describimos las características del Voto Anticipado.
      </p>
      {data && data.indexOf(3) && <MatApoyo array={[data[3]]}/>}<br/><br/>
      <p>
        Y ahora revisemos la última modalidad de votación: <b>El Voto de las Personas en Prisión Preventiva.</b>
      </p>
      <p>
        Los requisitos para el <b>voto de las y los ciudadanos que se encuentran en prisión preventiva</b> incluyen: encontrarse en prisión 
        preventiva en algún centro penitenciario participante, manifestar su intención de registrarse en la Lista Nominal de Electores en 
        Prisión Preventiva (LNEPP) mediante una solicitud y que ésta haya sido dictaminada como procedente.
      </p>
      <p>
        La LNEPP se generará por entidad federativa, distrito electoral federal, municipio y, en su caso, por distrito electoral local. 
        Incluye a las personas cuyas solicitudes fueron aprobadas y a aquellas que se incorporan a la lista por orden del Tribunal Electoral 
        del Poder Judicial de la Federación.
      </p>
      <p>
        En mayo de 2024 se habilitará un área de votación en cada centro penitenciario participante en la que las y los ciudadanos en 
        prisión preventiva cuya solicitud fue dictaminada como procedente, recibirán un paquete de correspondencia personalizado (SPES 
        Penal) con instrucciones de votación, información sobre candidaturas, boleta(s) electoral(es) y sobres para enviar el voto de 
        vuelta al INE. Posteriormente, los sobres con votos se trasladarán a la sede de la Junta Distrital correspondiente para que sean 
        contabilizados el día de la Jornada Electoral en las mesas de escrutinio y cómputo del Voto de las Personas en Prisión Preventiva 
        (MEC VPPP), órganos electorales integrados por funcionarias y funcionarios doblemente insaculados y capacitados por el INE.
      </p>
      <p>
        Revisa el siguiente video para identificar a detalle las características de esta modalidad de votación.
      </p>
      {data && data.indexOf(4) && <MatApoyo array={[data[4]]}/>}<br/><br/>
      <p>
        No olvides consultar el <b className="textoResaltado2">CAPÍTULO 8 DE TU {data && data.indexOf(6) && <MatApoyo array={[data[6]]} tipo={1}/>}</b> que está disponible 
        en los materiales de consulta de este curso, así como el siguiente material de apoyo para que refuerces tus conocimientos. 
      </p>
      {data && data.indexOf(5) && <MatApoyo array={[data[5]]}/>}
      <p>
        ¡Muy bien! Ya estás preparado para realizar la evaluación del tema modalidades de la votación. 
      </p>
    </div>
  );
}
